import { render } from "./ProfileAnagraph.vue?vue&type=template&id=5c31b53a&ts=true"
import script from "./ProfileAnagraph.vue?vue&type=script&lang=ts"
export * from "./ProfileAnagraph.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Profile/ProfileAnagraph.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c31b53a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c31b53a', __exports__)) {
    api.reload('5c31b53a', __exports__)
  }
  
  module.hot.accept("./ProfileAnagraph.vue?vue&type=template&id=5c31b53a&ts=true", () => {
    api.rerender('5c31b53a', render)
  })

}


export default __exports__